/* eslint-disable radix */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Avatar, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SimpleNoFilterReactTable from 'components/table/SimpleNoFilterReactTable';
import { getAgendaColorOrNull } from 'commons/helpers/agendaTheme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// COMPONENT
function CourtListTable({ dataSource, onSelect, onDelete, onEdit }) {
  const columns = [
    {
      Header: 'Nome',
      accessor: 'name',
      Cell: ({ cell }) => {
        const colorSelected = cell.row.original.colorId
          ? getAgendaColorOrNull(cell.row.original.colorId).header
          : 'transparent';

        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              borderLeft: `8px solid ${colorSelected}`,
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
          >
            <Avatar
              src={cell.row.original.avatarUrl}
              style={{
                marginLeft: '8px',
                marginRight: 10,
                backgroundColor: colorSelected === 'transparent' ? null : colorSelected,
              }}
            >
              <FontAwesomeIcon color="rgb(244, 246, 248)" icon="court-sport" size="sm" />
            </Avatar>
            <div style={{ flexDirection: 'column' }}>
              <Typography variant="body1">{cell.value}</Typography>
            </div>
          </div>
        );
      },
    },
  ];

  const initialState = React.useMemo(() => ({ pageSize: 25, sortBy: [] }), []);

  const customActions = [
    {
      id: 'edit',
      title: 'Editar',
      handler: (row, event) => {
        event.stopPropagation();
        event.preventDefault();
        onEdit(row.original);
      },
      icon: <EditIcon color="primary" />,
      hiddable: true,
    },
    {
      id: 'delete',
      title: 'Deletar',
      handler: (row, event) => {
        event.stopPropagation();
        event.preventDefault();
        onDelete(row.original);
      },
      icon: <DeleteIcon color="error" />,
      hiddable: true,
    },
  ];

  return (
    <SimpleNoFilterReactTable
      dataSource={dataSource}
      columns={columns}
      initialState={initialState}
      onSelectCallback={onSelect}
      hideDelete
      hideEdit
      customActions={customActions}
      getCellProps={(cell) => {
        if (cell && cell.column.Header === 'Nome') {
          return {
            style: {
              padding: '0px 24px 0px 0px',
            },
          };
        }
        return null;
      }}
      getHeaderProps={(column) => {
        if (column && column.Header === 'Nome') {
          return {
            style: {
              padding: '10px 16px 10px 22px',
            },
          };
        }
        return null;
      }}
    />
  );
}

export default CourtListTable;
